import React, {Component} from 'react';
import RaisedButton from 'material-ui/lib/raised-button';
import TextField from 'material-ui/lib/text-field';
import Checkbox from 'material-ui/lib/checkbox';
import Slider from 'material-ui/lib/slider';
import Relay from 'react-relay';
import cookie from '../../helper/cookie'
import NavbarLogin from '../../components/navbarLogin'
class FillSurvey extends Component{

  //receivedJson = {"project_id":"","conflicting_questions":{"timestamps":[1460703085720,1460703167192],"mapping":[]},"childrenStates":[{"question_text":"question 1","isToggled":false,"type":"Subjective","timestamp":1460703075714,"mcq_options":["","","",""],"slider_options":["1:10",["","",""]]},{"question_text":"question 2","isToggled":false,"type":"MCQ","timestamp":1460703085720,"mcq_options":["opt me!","No, opt me!","MEEEEE!!!","phew, me? :)"],"slider_options":["1:10",["","",""]]},{"question_text":"question 3","isToggled":false,"type":"Slider","timestamp":1460703137569,"mcq_options":["","","",""],"slider_options":["1:40",["YEAHHH","UMMMMMM...","NOOOPPP"]]},{"question_text":"","isToggled":false,"type":"MCQ","timestamp":1460703167192,"mcq_options":["option tionop 1","similary, 2","haha, i am 3","44444444444444444444"],"slider_options":["1:10",["","",""]]},{"question_text":"Say my name!","isToggled":false,"type":"Subjective","timestamp":1460703217644,"mcq_options":["","","",""],"slider_options":["1:10",["","",""]]}]}

// receivedJson =  {
//       "project_id":"",
//       "conflicting_questions":{
//           "timestamps":[
//               1460703085720,
//               1460703167192
//           ],
//           "mapping":[

//           ]
//       },
//       "childrenStates":[
//           {
//               "question_text":"Question 1",
//               "isToggled":false,
//               "type":"Subjective",
//               "timestamp":1460703075714,
//               "mcq_options":[
//                   "",
//                   "",
//                   "",
//                   ""
//               ],
//               "slider_options":[
//                   "1:10",
//                   [
//                       "",
//                       "",
//                       ""
//                   ]
//               ]
//           },
//           {
//               "question_text":"Question 2",
//               "isToggled":false,
//               "type":"MCQ",
//               "timestamp":1460703085720,
//               "mcq_options":[
//                   "opt me!",
//                   "No, opt me!",
//                   "MEEEEE!!!",
//                   "phew, me? :)"
//               ],
//               "slider_options":[
//                   "1:10",
//                   [
//                       "",
//                       "",
//                       ""
//                   ]
//               ]
//           },
//           {
//               "question_text":"Question 3",
//               "isToggled":false,
//               "type":"Slider",
//               "timestamp":1460703137569,
//               "mcq_options":[
//                   "",
//                   "",
//                   "",
//                   ""
//               ],
//               "slider_options":[
//                   "1:40",
//                   [
//                       "YEAHHH",
//                       "UMMMMMM...",
//                       "NOOOPPP"
//                   ]
//               ]
//           },
//           {
//               "question_text":"Question 4",
//               "isToggled":false,
//               "type":"MCQ",
//               "timestamp":1460703167192,
//               "mcq_options":[
//                   "option tionop 1",
//                   "similary, 2",
//                   "haha, i am 3",
//                   "44444444444444444444"
//               ],
//               "slider_options":[
//                   "1:10",
//                   [
//                       "",
//                       "",
//                       ""
//                   ]
//               ]
//           },
//           {
//               "question_text":"Say my name!",
//               "isToggled":false,
//               "type":"Subjective",
//               "timestamp":1460703217644,
//               "mcq_options":[
//                   "",
//                   "",
//                   "",
//                   ""
//               ],
//               "slider_options":[
//                   "1:10",
//                   [
//                       "",
//                       "",
//                       ""
//                   ]
//               ]
//           }
//       ]
//   }

  receivedJson = {};

  constructor(props) {
    super(props);

      this.state = {
      project_id:"",
      response_time:"",
      conflicting_questions : [],
      answers : [],
      childrenStates : []
    }
    this.change=this.change.bind(this);
    //console.log(this.receivedJson);
  }

  // state = {
  //   project_id : "",
  //   conflicting_questions : receivedJson.conflicting_questions,
  //   childrenStates :
  //
  // }
componentWillMount(){
    var url = 'http://surveymate-io.herokuapp.com/api/questions/getQuestions?project_id='+this.props.viewer.pid;
    var responseCode;
    var responseText;
    var self=this;
    var rj,length,arr;
    // console.log(params);
    var response = fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      }
    }).then(function (response) {
        responseCode = response.status;
        responseText = response.statusText;
        return response.text();
    }).then(function (result) {
        var jsonData = JSON.parse(result);
        if (responseCode == 200) {
          console.log(jsonData);
          self.receivedJson=jsonData;
          rj = self.receivedJson;
          length = self.receivedJson.childrenStates.length;
          arr = self.receivedJson.childrenStates.map(function(s){
          return({
              "id":s.id,
              "type":s.type,
              "answer_text":"",
              "mcq_answer":[],
              "slider_answer":0
            });
          });

          self.change(rj,arr);
      
        }
        else {
          console.log("failure");
        }
    }).catch(function (error) {
      console.error('An error occured');
      console.error(error);
    });
    // console.log(this.receivedJson);
    //this.state = {count: props.initialCount};
    // var arr = [];
    // var i = 0;
    // for ( i = 0; i <length; i++){
    //   arr[i] = "";
    // }
}
change(rj,arr){
  this.setState({
      project_id:this.props.viewer.pid,
      conflicting_questions : rj.conflicting_questions,
      answers : arr,
      childrenStates : rj.childrenStates
  });
}
 handleSubjective = (timestamp,e) => {
   //console.log(e.target.value);
   var temp = this.state;
   var i = 0;
   for (i = 0; i < temp.childrenStates.length; i++ ){
     if ( timestamp == temp.childrenStates[i].timestamp ){
       temp.answers[i].answer_text = e.target.value;
       this.setState(temp);
       break;
     }
   }
 }

 handleMCQ = (timestamp,option,e) => {
   console.log(option);
   var temp = this.state;
   var i = 0;
   for (i = 0; i < temp.childrenStates.length; i++ ){
     if ( timestamp == temp.childrenStates[i].timestamp ){
       var arr = temp.answers[i].mcq_answer;
       if (arr.indexOf(option) < 0){
         arr.push(option);
         temp.answers[i].mcq_answer = arr;
       }else{
         arr.splice(arr.indexOf(option),1);
         temp.answers[i].mcq_answer = arr;
       }
       console.log(temp.answers[i].mcq_answer);
       this.setState(temp);
       break;
     }
   }
 }

 handleSlider = (timestamp,idk,value) => {
   var temp = this.state;
   var i = 0;
   for (i = 0; i < temp.childrenStates.length; i++ ){
     if ( timestamp == temp.childrenStates[i].timestamp ){
       temp.answers[i].slider_answer = parseInt(value);
       this.setState(temp);
       break;
     }
   }
 }


submit = () => {
  // console.log(this.state);
  if (cookie.get(this.props.viewer.pid)==null || cookie.get(this.props.viewer.pid)=="false"){
    
    var date = new Date();
    var obj = {"info": this.state}
    obj.info.response_time = date.toISOString();
    var params = JSON.stringify(obj);
    console.log(params);
    var url = 'http://surveymate-io.herokuapp.com/api/responses/submitForm';
    var responseCode;
    var responseText;
    var self=this;
    var response = fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: params
    }).then(function (response) {
        responseCode = response.status;
        responseText = response.statusText;
        return response.text();
    }).then(function (result) {
        // var jsonData = JSON.parse(result);
        if (responseCode == 200) {
          console.log("success");
          document.cookie = self.props.viewer.pid + " = true"
          // alert("Form succesfully created")
        }
        else {
          console.log("failure");
        }
    }).catch(function (error) {
      console.error('An error occured');
      console.error(error);
    });
  }
  else {
    alert("You have already submitted a response.");
  }
}

  render(){
    //console.log(this.state.childrenStates.length);
  //console.log(this.state);
    var fs = this.handleSubjective;
    var fm = this.handleMCQ;
    var fsd = this.handleSlider;

    var questions = this.state.childrenStates.map(function(passedState){
      switch ( passedState.type ){
        case "Subjective":
          // console.log("subjective");
          return(
            <div className="well">
              <span className="h3">{passedState.question_text}</span><br />
              <div>
                <TextField hintText="Your response" onChange={fs.bind(this,passedState.timestamp)}  />
              </div>
            </div>
          );

          break;

        case "MCQ":
          // console.log("mcq");
          return(
            <div className="well">
              <span className="h3">{passedState.question_text}</span><br />
              <div>
              <input type="checkbox" label={passedState.mcq_options[0]} onChange={fm.bind(this,passedState.timestamp, 1)} />
              <span>&nbsp;{passedState.mcq_options[0]}</span><br />
              <input type="checkbox" label={passedState.mcq_options[1]} onChange={fm.bind(this,passedState.timestamp, 2)} />
              <span>&nbsp;{passedState.mcq_options[1]}</span><br />
              <input type="checkbox" label={passedState.mcq_options[2]} onChange={fm.bind(this,passedState.timestamp, 3)} />
              <span>&nbsp;{passedState.mcq_options[2]}</span><br />
              <input type="checkbox" label={passedState.mcq_options[3]} onChange={fm.bind(this, passedState.timestamp, 4)} />
              <span>&nbsp;{passedState.mcq_options[3]}</span><br />
              </div>
            </div>
          );
          break;

        case "Slider":
          // console.log("slider");
          return(
            <div className="well">
              <span className="h3">{passedState.question_text}</span><br />
              <div>
                <Slider min={parseInt(passedState.slider_options[0].split(":")[0])} value={1} max={parseInt(passedState.slider_options[0].split(":")[1])} onChange={fsd.bind(this, passedState.timestamp)}/>
              </div>
            </div>
          );
          break;

        default:
          break
      }
    });
    return(
      <div>
        <div>
          <NavbarLogin />
        </div>
        <center style={{maxWidth:700}} className="container-fluid">
        {questions}
        <RaisedButton label="GO" primary={true} onClick={this.submit} style={{backgroundColor:"#0000FF"}} />
        </center>
      </div>
    );
  }

}

export default Relay.createContainer(FillSurvey, {
  initialVariables: {
    status: null
  },
  fragments: {
    viewer: () => Relay.QL`
      fragment on Conversation {
        name
        pid
      }
    `
  }
});




/** WEBPACK FOOTER **
 ** ./src/views/responses/index.js
 **/